/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { type OAuthRedirectResponse } from '../../types'
import api from '../api'

const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    loginDev: builder.mutation<void, string>({
      query: (userId: string) => ({
        url: `auth/login-dev?userId=${userId}`,
        method: 'POST',
        headers: { 'X-Dev-Secret': import.meta.env.VITE_DEV_SECRET ?? '' },
      }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({ url: 'auth/logout', method: 'POST' }),
      invalidatesTags: ['User'],
    }),
    socialSignup: builder.mutation<OAuthRedirectResponse, { platform: string }>({
      query: ({ platform }) => ({
        url: `auth/social-signup/${platform}`,
        method: 'POST',
      }),
    }),
  }),
})

export const { useLogoutMutation, useLoginDevMutation, useSocialSignupMutation } = authApi

export default authApi
